export default __webpack_public_path__ + "locales/hy-AM/UploadPanel.json?hash=415a3bbdb7a7958e62aade82a4522f6a";